"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThThThb = exports.EnThThb = void 0;
class EnThThb {
    constructor() {
        this.locale = "en-th";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "d MMMM yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "THB",
            symbol: "THB",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnThThb = EnThThb;
class ThThThb {
    constructor() {
        this.locale = "th-th";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "d MMMM yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "THB",
            symbol: "THB",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.ThThThb = ThThThb;
